import { render, staticRenderFns } from "./IssueItemModal.vue?vue&type=template&id=7e9fd6d0&"
import script from "./IssueItemModal.vue?vue&type=script&lang=js&"
export * from "./IssueItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports